import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { useAppStore } from "@/store";
import { MDSText, MDSTextVariant } from "@/mds";
import type { FC } from "react";

interface ImportModalHeaderProps {
  slot?: string;
}

export const ImportModalHeader: FC<ImportModalHeaderProps> = observer(function ImportModalHeader({
  slot,
}) {
  const { store } = useAppStore();

  const { isLoading, totalNotesCount, selectedNotesCount } = store.oneClickImport;
  const hasNotes = totalNotesCount > 0;

  const getTitle = () => {
    if (isLoading) {
      return "Loading data from Apple Notes";
    }

    if (!hasNotes) {
      return "Importing 0 notes";
    }

    return `Importing ${selectedNotesCount} of ${totalNotesCount} notes`;
  };

  return (
    <StyledTitle slot={slot} variant={MDSTextVariant.HeaderL}>
      {getTitle()}
    </StyledTitle>
  );
});

const StyledTitle = styled(MDSText)`
  padding-left: ${({ theme }) => theme.spacing[3]};
  flex: 1;
`;
